import sumBy from "lodash/sumBy";

import { ProductLine, QuoteRequestLine } from "../types";

export const computeProductsCost = ({
  productLines,
  quoteRequestLineQuantity,
  quantityInAssembly,
}: {
  quoteRequestLineQuantity: QuoteRequestLine["quantity"];
  productLines: ProductLine[];
  quantityInAssembly: number | null;
}) => {
  const productCost = sumBy(productLines, (productLine) => {
    return (
      productLine.price *
        productLine.quantity *
        (productLine.isQuantityPerPart ? quoteRequestLineQuantity * (quantityInAssembly ?? 1) : 1) +
      (productLine.fixedPrice ?? 0)
    );
  });

  return productCost;
};
